import React, { useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import "./report.css"; // Custom CSS file for styling

const PhysicalProgressChart = (props) => {
  const data = {
    labels: props?.data?.labels,
    datasets: [
      {
        data: props?.data?.data, // Percentage values
        backgroundColor: ["rgba(255, 184, 0, 1)", "#0ebd0e"], // Colors for the sections
        hoverBackgroundColor: ["rgba(255, 184, 0, 1)", "#0ebd0e"],
        borderWidth: 0,
      },
    ],
  };
  const options = {
    cutout: "70%", // Inner radius for the donut
    plugins: {
        tooltip: {
          enabled: false,
        },
        legend: {
          display: false,
          position: 'right',
        },
        datalabels: {
          formatter: (value, context) => {
            return `${value}%`;
          },
          color: '#FFF',
          font: {
            weight: 'bold',
          },
        },
      },
  };

  return (
    <div className="ncr-tracker">
      <div className="chart-container">
        <Doughnut data={data} options={options} />
        <div className="chart-center">
          {/* <span className="total-count">17</span><br/>
          <span className="total-label">Total Ncr</span> */}
        </div>
      </div>
      <div className="chart-legend">
        <div className="legend-item">
          <div className="legend-color closed" style={{backgroundColor:"rgba(255, 184, 0, 1)"}}></div>
          <span>Pending</span>
        </div>
        <div className="legend-item">
          <div className="legend-color open"></div>
          <span>Completed</span>
        </div>
      </div>
    </div>
  );
};

export default PhysicalProgressChart;